import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql, StaticQuery } from 'gatsby'
import Img from "gatsby-image"


class OfferRoll2 extends React.Component {
  render() {
    const { data } = this.props

    const { edges: posts } = data.allMarkdownRemark

    return (
      <div>
      <div className="columns is-multiline" style={{marginLeft:'0',marginRight:'0',marginTop:'50px',marginBottom:'0',padding:'2%',width:'100%',justifyContent:'center',flexWrap:'wrap'}}>
        {posts &&
          posts
          .map(({ node: post }) => (
            <Link className="column is-4 no-hover" key={post.id} to={post.fields.slug}>
            <div className="offers" style={{textAlign:'center'}}>
            {post.frontmatter.icon ?
              post.frontmatter.icon.childImageSharp ?
               <Img fluid={post.frontmatter.icon.childImageSharp.fluid}
               alt={post.frontmatter.title}
               title={post.frontmatter.title}
               style={{height:'70px',width:'70px',margin:'auto',marginTop:'15px',objectFit:'contain'}}
               imgStyle={{height:'70px',width:'70px',objectFit:'contain'}}
              />
              :
              <img src={post.frontmatter.icon.publicURL} style={{margin:'10px auto'}} width="70px" height="70px" alt={post.frontmatter.title} title={post.frontmatter.title} loading="lazy" />
            :null}
            <br></br>
            <h2 style={{minHeight:'75px',maxWidth:'170px'}}><strong>{post.frontmatter.title}</strong></h2>
            <div style={{textAlign:'left',padding:'15px'}}>
            <p style={{fontSize:'13px',marginBottom:'20px',textAlign:'left'}}>{post.frontmatter.description.slice(0,300)+'...'}</p>
            </div>
            </div>
            </Link>
          ))}
      </div>
      </div>

    )
  }
}

OfferRoll2.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default () => (
  <StaticQuery
    query={graphql`
      query OfferRollQuery2 {
        allMarkdownRemark(
          limit: 9,
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "offer-page" } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              timeToRead
              frontmatter {
                title
                templateKey
                description
                date(formatString: "DD. MM. YYYY")
                icon {
                  childImageSharp {
                    fluid(maxWidth: 1000) {
                      srcWebp
                      src
                      srcSet
                      srcSetWebp
                    }
                  }
                  publicURL
                }
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <OfferRoll2 data={data} count={count} />}
  />
)
